import { Action } from '@ngrx/store';
import { ThreeDS2ReducerInitState } from '../models/threeDS2-reducer.interface';

export const UPDATE_3DS_DATA = 'UPDATE_3DS_DATA';
export const RESET_3DS_STATE = 'RESET_3DS_STATE';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: ThreeDS2ReducerInitState = {
  data: {
    request: '',
    postURL: '',
    originURL: '',
    type: '',
    paymentSessionId: '',
    paymentRequest: '',
    termUrl: '',
    issueUrl: '',
    notificationUrl: ''

  }
};

export function threeDS2Reducer (state: ThreeDS2ReducerInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {

    case UPDATE_3DS_DATA:
      return Object.assign({}, state, { data: action.payload });

    case RESET_3DS_STATE:
      state = Object.assign({}, initState);
      return state;

    default:
      return state;
  }

};
